import * as React from "react";
const SvgContactS = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", viewBox: "0 0 18 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.2, d: "M3.75 15.75a5.25 5.25 0 1 1 10.5 0M12 5.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0" }));
export default SvgContactS;
